namespace RedBullMOBILE360.SMSCodes {
    export namespace ServiceSmsService {
        export const baseUrl = 'SMSCodes/ServiceSms';

        export declare function Create(request: Serenity.SaveRequest<ServiceSmsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ServiceSmsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ServiceSmsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ServiceSmsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadImage(request: Serenity.Extensions.ExcelImportRequest, onSuccess?: (response: Serenity.Extensions.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SMSCodes/ServiceSms/Create",
            Update = "SMSCodes/ServiceSms/Update",
            Delete = "SMSCodes/ServiceSms/Delete",
            Retrieve = "SMSCodes/ServiceSms/Retrieve",
            List = "SMSCodes/ServiceSms/List",
            UploadImage = "SMSCodes/ServiceSms/UploadImage"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'UploadImage'
        ].forEach(x => {
            (<any>ServiceSmsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
